<template>
    <div class="full-h">
        <div class="row full-h">
            <div class="column-center">
                <slot name="header"></slot>
                <slot name="content"></slot>
            </div>
            <div class="column-right">
                <slot name="tabs"></slot>
            </div>
        </div>
        <slot name="footer"></slot>
    </div>
</template>

<script>
export default {
    name: "Structure_TabsRight"
}
</script>